

























import { Component, Vue } from 'vue-property-decorator'
import authModule from '@/store/auth'
import dealModule from '@/store/deal'
import DealBookmarkCard from '@/components/deal/DealBookmarkCard.vue'
import { Category } from '@/types/Types'
import { Deal } from '@/types/Deal'

@Component({
  name: 'RewardList',
  components: {
    DealBookmarkCard
  }
})
class RewardList extends Vue {
  private categories: Category[] = []

  private get user() {
    return authModule.user
  }

  private get deals() {
    return dealModule.rewards
  }

  private async openDeal(currentDeal: Deal): Promise<void> {
    await dealModule.setDeal(currentDeal)
    this.$router.push({
      name: 'DealDetail',
      params: { id: currentDeal._id }
    })
  }
}
export default RewardList
